import { isArray } from 'lodash';
import moment from 'moment';

import formatCurrency from 'Helper/formatCurrency';
import formatNumber from 'Helper/formatNumber';

const getReportAccountPlatformResponse = (response) => {
  const totalData = response?.totalData ?? 0;
  const totalPage = response?.totalPage ?? 0;
  const isDataExist = response?.isDataExist;
  const lastSync = moment(response?.lastSync).format('DD MMMM YYYY, HH:mm:ss');

  const reports = response?.liveSellingPerformance?.map((item) => {
    const id = item?.id;
    const account = {
      accountType: item?.accountTypeName,
      accountLivestreams: {
        ecommerce: item?.ecommerce,
        name: item?.accountName,
      },
      brand: isArray(item?.brands) && item?.brands[0]?.name,
    };

    return {
      id,
      account,
      totalGmv: formatCurrency(item?.totalGmv || 0),
      totalErrPercentage: `${formatNumber(item?.totalErrPercentage || 0, 1)}%`,
      totalCtrPercentage: `${formatNumber(item?.totalCtrPercentage || 0, 1)}%`,
      totalConversationRate: `${formatNumber(item?.totalConversationRate || 0, 1)}%`,
      totalAov: formatCurrency(item?.totalAov || 0),
      totalShareNumbers: formatNumber(item?.totalShareNumbers || 0, 1),
      totalCommentNumbers: formatNumber(item?.totalCommentNumbers || 0, 1),
      totalNewFollowers: formatNumber(item?.totalNewFollowers || 0),
      totalLikeNumbers: formatNumber(item?.totalLikeNumbers || 0),
      totalAwd: item?.totalAwd || '-',
      totalImpressions: formatNumber(item?.totalImpressions || 0),
      totalLiveDuration: item?.totalLiveDuration,
      totalViews: formatNumber(item?.totalViews || 0),
      totalViewers: formatNumber(item?.totalViewers || 0),
      rawData: item,
    };
  });

  return { reports, totalData, totalPage, isDataExist, lastSync };
};

export default getReportAccountPlatformResponse;
